import { render, staticRenderFns } from "./TransactionsView.vue?vue&type=template&id=612b002c&scoped=true&"
import script from "./TransactionsView.vue?vue&type=script&lang=ts&"
export * from "./TransactionsView.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionsView.vue?vue&type=style&index=0&id=612b002c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b002c",
  null
  
)

export default component.exports